import React from 'react';
import Icon from '../../../components/AppIcon';

const logos = [
  { name: 'Stripe', icon: 'CreditCard' },
  { name: 'Zapier', icon: 'Zap' },
  { name: 'Slack', icon: 'MessageSquare' },
  { name: 'HubSpot', icon: 'BarChart2' },
  { name: 'Salesforce', icon: 'Cloud' },
  { name: 'Mailchimp', icon: 'Mail' },
];

const SocialProofBar = () => {
  return (
    <section className="bg-[#f5faf6] border-y border-gray-100 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 mb-12">
          {[
            { value: '50+', label: 'Field types for flexible forms' },
            { value: 'Free', label: 'Plan available to get started' },
            { value: 'No code', label: 'Visual drag-and-drop building' },
            { value: 'Unlimited', label: 'Team seats on paid plans' },
          ]?.map(({ value, label }) => (
            <div key={label} className="text-center">
              <div className="text-3xl lg:text-4xl font-heading font-bold text-gray-900 mb-1">{value}</div>
              <div className="text-sm text-gray-500">{label}</div>
            </div>
          ))}
        </div>

        {/* Integration logos */}
        <div className="text-center">
          <p className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-6">Connects with your favorite tools</p>
          <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-10">
            {logos?.map(({ name, icon }) => (
              <div key={name} className="flex items-center gap-2 text-gray-400 hover:text-gray-600 transition-colors">
                <Icon name={icon} size={18} />
                <span className="text-sm font-semibold">{name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProofBar;
